import { configurationSettings } from '../../../../configuration/configuration-settings';
export const getInProgressItemModifierSelections = (inProgressItemModifierGroup, quantityLimit, newQuantity, modifierItemId, inheritedItemPrice) => {
    const modifierSelections = inProgressItemModifierGroup.modifiers.map(modifier => ({
        itemId: modifier.itemId,
        quantity: getQuantity(modifier, quantityLimit, newQuantity, modifierItemId),
        selectedPrice: modifierItemId === modifier.itemId ? inheritedItemPrice : modifier.selectedPrice
    }));
    return modifierSelections;
};
const getQuantity = (inProgressModifier, quantityLimit, newQuantity, modifierItemId) => {
    const max = !quantityLimit.isUnlimited ? quantityLimit.maximum : undefined;
    // If the modifier being updated is calling get quantity, then the quantity gets set as the new value that was passed in.
    if (modifierItemId === inProgressModifier.itemId) {
        return Math.min(newQuantity, max || configurationSettings.data.order.maximumModifiersPerItem);
    }
    // When these conditions are met, the quantity picker will be rendered as a radio button and will be set to deselected. Returning 0 to reflect deselected state.
    // If a radio button is being updated, then only the if above will be executed.
    if (max === 1)
        return 0;
    return inProgressModifier.quantity;
};
